import React, { useContext } from "react";
import { ChannelContext } from "../contexts";
import "../assets/styles/content_section.sass";
import "../assets/styles/404_page.sass";
import Utility from "../Utility";

const NoPage = ({ content }) => {
  const channelId = useContext(ChannelContext);
  const channel = Utility.getChannel(content, channelId);
  return (
    <div className="ur-mini-main ur-mini-404">
      <div
        className="ur-mini-main-overlay"
        style={{
          backgroundColor:
            channel && channel.colors && channel.colors.main
              ? channel.colors.main
              : "initial",
        }}
      ></div>
      <h1>404</h1>
    </div>
  );
};

export default NoPage;
